/* --- Global Custom Optimized JS --- */

// 1. IE Compatibility Check (from snippets/cart-drawer.liquid)
document.addEventListener('DOMContentLoaded', function () {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return msie > 0 || trident > 0;
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement('input');
  cartSubmitInput.setAttribute('name', 'checkout');
  cartSubmitInput.setAttribute('type', 'hidden');
  const cartForm = document.querySelector('#cart');
  if (cartForm) {
    cartForm.appendChild(cartSubmitInput);
  }
  const checkoutBtn = document.querySelector('#checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (event) {
      if (cartForm) cartForm.submit();
    });
  }
});

// 2. Cart Drawer Scroll Behavior (from snippets/cart-drawer.liquid)
function checkCartScroll() {
  const wrapper = document.querySelector('.cart-drawer-items');
  const footer = document.querySelector('.drawer__footer');

  if (!wrapper || !footer) return;

  if (wrapper.scrollHeight > wrapper.clientHeight) {
    footer.classList.add('with-border');
  } else {
    footer.classList.remove('with-border');
  }
}

window.addEventListener('load', checkCartScroll);
window.addEventListener('resize', checkCartScroll);

document.addEventListener('DOMContentLoaded', function() {
  const cartContainer = document.querySelector('#CartDrawer-CartItems');
  if (cartContainer) {
    const observer = new MutationObserver(checkCartScroll);
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
});

// 3. AED Double-Barred D Currency Formatter (from layout/theme.liquid)
(function() {
  const aedIcon = `<span class="aed-currency-symbol" style="display: inline-flex; align-items: center; justify-content: center; height: 1.1em; width: 0.95em; vertical-align: -0.15em; position: relative; margin-right: 0.12em; color: inherit;" title="AED"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="width: 100%; height: 100%; display: block;"><path d="M 6,3 L 13,3 A 8,8 0 0 1 13,21 L 6,21 Z" /><path d="M 2,9 L 20,9" /><path d="M 2,14 L 20,14" /></svg></span>`;

  function formatCurrencyText(text) {
    if (!text) return text;
    return text.replace(/\b(DHS|Dhs\.|Dhs|dhs|AED|aed)\b/g, aedIcon);
  }

  function scanAndReplaceCurrency(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const val = node.nodeValue;
      if (/\b(DHS|Dhs\.|Dhs|dhs|AED|aed)\b/.test(val)) {
        const span = document.createElement('span');
        span.innerHTML = formatCurrencyText(val);
        node.parentNode.replaceChild(span, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('aed-currency-symbol')) {
      if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE' && node.tagName !== 'TEXTAREA' && node.tagName !== 'INPUT') {
        Array.from(node.childNodes).forEach(scanAndReplaceCurrency);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    scanAndReplaceCurrency(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          scanAndReplaceCurrency(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  if (window.theme && window.theme.moneyFormat) {
    window.theme.moneyFormat = formatCurrencyText(window.theme.moneyFormat);
  }
})();

// 4. Category Grid Symmetry Slider/Scroller (from sections/catagory.liquid)
document.addEventListener('DOMContentLoaded', function() {
  const initOrizonCatSliders = () => {
    const sliders = document.querySelectorAll('.orizon-cat-slider-master');
    sliders.forEach(sliderMaster => {
      if (sliderMaster.dataset.initialized === 'true') return;
      sliderMaster.dataset.initialized = 'true';

      const scroller = sliderMaster.querySelector('.orizon-cat-scroller-track');
      const prevBtn = sliderMaster.querySelector('.orizon-cat-arrow-prev');
      const nextBtn = sliderMaster.querySelector('.orizon-cat-arrow-next');
      if (!scroller || !prevBtn || !nextBtn) return;

      const card = scroller.querySelector('.orizon-cat-item');
      if (!card) return;

      prevBtn.onclick = (e) => {
        e.preventDefault();
        const scrollStep = card.offsetWidth + 20;
        scroller.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      };

      nextBtn.onclick = (e) => {
        e.preventDefault();
        const scrollStep = card.offsetWidth + 20;
        scroller.scrollBy({ left: scrollStep, behavior: 'smooth' });
      };
    });
  };

  initOrizonCatSliders();
  document.addEventListener('shopify:section:load', initOrizonCatSliders);
});

// 5. Shop by Category Color Slider Drag/Scroll (from sections/shop-bycolorategory.liquid)
document.addEventListener('DOMContentLoaded', function() {
  const initOrizonColorSliders = () => {
    const wrappers = document.querySelectorAll('.orizon-color-cat-wrapper');
    wrappers.forEach(wrapper => {
      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      const slider = wrapper.querySelector('.orizon-color-cat-grid');
      const btnLeft = wrapper.querySelector('.orizon-color-cat-scroll-left');
      const btnRight = wrapper.querySelector('.orizon-color-cat-scroll-right');
      if (!slider || !btnLeft || !btnRight) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let isMoving = false;

      btnLeft.addEventListener("click", () => {
        slider.scrollBy({ left: -350, behavior: 'smooth' });
      });

      btnRight.addEventListener("click", () => {
        slider.scrollBy({ left: 350, behavior: 'smooth' });
      });

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        isMoving = false;
        slider.classList.add("dragging");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("dragging");
      });

      slider.addEventListener("mouseup", () => {
        setTimeout(() => { isMoving = false; }, 50);
        isDown = false;
        slider.classList.remove("dragging");
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; 
        if (Math.abs(walk) > 5) isMoving = true;
        slider.scrollLeft = scrollLeft - walk;
      });

      slider.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          if (isMoving) {
            e.preventDefault();
          }
        });
      });
    });
  };

  initOrizonColorSliders();
  document.addEventListener('shopify:section:load', initOrizonColorSliders);
});

